export default __webpack_public_path__ + "static/media/logoPetiscos1444-512px.702591a2.png";